export default "__VITE_ASSET__DcYKtBm8__"